'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserQueryFeatureNames = undefined;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _getQueryFeatureNames = require('./get-query-feature-names');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBrowserQueryFeatureNames = exports.getBrowserQueryFeatureNames = function getBrowserQueryFeatureNames() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof window === 'undefined' ? '' : window.location.search;

  var _parse = (0, _urlParse2.default)(search, true),
      query = _parse.query;

  return (0, _getQueryFeatureNames.getQueryFeatureNames)(query);
};